import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import apiClient from "../../../../../helpers/api-client";

export type Assessment = {
	id: number;
	name?: string;
};

const assessmentsApi = createApi({
	reducerPath: "assessments",
	baseQuery: async (arg, api, extraOptions) =>
		fetchBaseQuery({
			fetchFn: apiClient.fetch.bind(apiClient),
			baseUrl: `/api/verity`,
		})(arg, api, extraOptions),
	tagTypes: ["Assessment"],
	endpoints: (builder) => ({
		getAssessment: builder.query<Assessment, number>({
			query: (id) => `assessment/${id}`,
			transformResponse: ({ id, quizInfo }: { id: number; quizInfo?: { name?: string } }) => ({
				id,
				name: quizInfo?.name,
			}),
			providesTags: (result) => (result ? [{ type: "Assessment" as const, id: result.id }] : ["Assessment"]),
		}),
	}),
});

export default assessmentsApi;
